// extracted by mini-css-extract-plugin
export default {"responsive":"StoreFeedActivityModal_responsive_HnvxU"};